<template>
<div class="page-title">
    <div class="title">
        <h3>Tickets</h3>
    </div>
    <div class="filters">
        <el-form
            label-position="top"
        >
            <el-row>
                <el-col :span="3">
                    <el-form-item label="Stage">
                        <el-select v-model="form.stage"  placeholder="Select" size="small" >
                            <el-option
                                v-for="item in stages"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>



                <el-col :span="3">
                    <el-form-item class="ml-2" label=" .">
                    <el-button @click="form.page=1;getlist()"  type="primary" size="small"  round >Apply Filters</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="15">

                </el-col>
                <el-col :span="3">
                    <el-input @change="form.page=1;getlist()" v-model="form.search" placeholder="Search here.." clearable />
                </el-col>
            </el-row>



        </el-form>



    </div>
</div>

    <div v-if="!loading">
        <el-card class="box-card mt-2 booking-list-box" v-for="ticket in tickets" :key="ticket.id" >
            <template #header>
                <el-row >
                    <el-col :span="6">
                        <el-tag class="mr-2 bdark" effect="dark" >TKT{{ticket.id}}</el-tag>
                        <el-tag class="mr-2" style="" v-if="ticket.enquiry_id!=null" @click="openenquiry(ticket.enquiry_id_ecpt)">
                            CDM{{ticket.enquiry_id}}</el-tag>
                        <el-tag class="mr-2" style="" >
                            {{ticket.created_at}}</el-tag>
                        <el-tag class="mr-2" >
                            {{ticket.created_for_department}}</el-tag>
                        <el-tag class="mr-2" style="" v-if="ticket.createdfor!=null">
                            <el-avatar class="mr-2" :size="20" :src="'https://crm.pickotrip.com/images/agents/'+ticket.createdfor+'.jpg'" />
                            {{ticket.createdfor}}</el-tag>

                    </el-col>
                    <el-col :span="18" >
                        <el-row justify="end">

                           <el-tag class="mr-2" effect="dark" type="primary"  >{{ticket.created_by_department}}</el-tag>
                            <el-tag class="mr-2" style="" >
                                <el-avatar class="mr-2" :size="20" :src="'https://crm.pickotrip.com/images/agents/'+ticket.createdby+'.jpg'" />
                                {{ticket.createdby}}</el-tag>
                            <el-tag class="mr-2" effect="dark" type="primary"  >{{ticket.priority}}</el-tag>
                            <el-tag class="mr-2" effect="dark" :type="ticket.status=='Open'? 'success' : ticket.status=='Pending'? 'warning' : 'danger'" >{{ticket.status}}</el-tag>

                        </el-row>
                    </el-col>

                </el-row>


            </template>
            <div  class="booking-contents">
                <div style="width: 100%">
                    <p class="lbl">{{ticket.category}}</p>
                    <el-collapse class="remark-box" accordion >
                        <el-collapse-item name="1">
                            <template #title>
                                Last Remark By &nbsp;<b>{{ticket.ticketlastlog.createdby}}</b>&nbsp; at &nbsp;<b>{{ticket.ticketlastlog.created_at}}</b>
                            </template>
                            <div>
                                <el-text class="mx-1" type="primary" ><span v-html="ticket.ticketlastlog.description"></span></el-text>

                            </div>
                            <div>
                                <a v-for="attachment in ticket.ticketlastlog.attachments" :href="attachment.link" target="_blank"><el-tag class="mr-2" type="info" >{{attachment.filename}}</el-tag></a>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>

            </div>
            <div class="bottom">
                <el-button text class="button" @click="openticket(ticket.viewlink)">View Ticket</el-button>
                <replay-tickets :ticket="ticket" @saved="getlist()"></replay-tickets>

            </div>
        </el-card>
        <el-row justify="center" v-if="total>0">
            <el-col justify="center">

                <el-space  ></el-space>
                <el-pagination style="width: fit-content;" v-model:current-page="form.page" class="mt-4 mb-4" :default-page-size="10" background layout="prev, pager, next" @current-change="pageChange" :total="total" />
                <el-space  ></el-space>

            </el-col>
        </el-row>
    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

</template>
<style>

</style>
<script>
import  { ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
export default {
    name: "BookingList",
    components: { ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    data() {
        return {
            loading: true,
            total:0,
            form:{
                page:1,
                stage:'0,1',
                type:'0',
                daterange:[moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')],
                user:'',
                search:''
            },
            stages:[
                {
                    value:'0,1',
                    label:'Pending/Opened'
                },
                {
                    value:'0',
                    label:'Pending'
                },
                {
                    value:'1',
                    label:'Opened'
                },
                {
                    value:'2',
                    label:'Closed'
                },
                {
                    value:'',
                    label:'All'
                },
            ],
            types:[
                {
                    value:'0',
                    label:'Booking Date'
                },
                {
                    value:'1',
                    label:'Departure Date'
                }

            ],
            dateshortcuts : [
                {
                    text: 'This Month',
                    value: () => {

                        return [moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last month',
                    value: () => {

                        return [moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last 3 months',
                    value: () => {
                        return [moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]

                    },
                },
                {
                    text: 'Next month',
                    value: () => {

                        return [moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().add(1, 'month').endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Next 3 months',
                    value: () => {
                        return [moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().add(3, 'month').endOf('month').format('YYYY-MM-DD')]

                    },
                },
                {
                    text: 'Next 10 Days',
                    value: () => {

                        return [moment().add(1, 'day').format('YYYY-MM-DD'),moment().add(10, 'day').format('YYYY-MM-DD')]
                    },
                },
            ],
            tickets:[],
            salesagents:[],

        }
    },
    mounted() {
        this.getlist();
    },
    methods: {
        getlist() {
            this.loading=true;
            let currentObj = this;
            axios.post('/tickets/list',this.form).then(function (response) {
                currentObj.tickets=response.data.tickets;
                currentObj.total=response.data.total;
                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        pageChange(page){
            this.form.page=page;
            this.getlist();
        },
        openticket(link){
          window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight);
        },
        openenquiry(id){
            window.open('/viewenquiry?id='+id, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)
        }

    }
}
</script>

<style scoped>

</style>
